import { useTheme } from '@chronosphereio/chrono-ui';
import React from 'react';
import { ReactComponent as CortexXCORNegative } from './XcorDarkModeExpanded.svg';
import { ReactComponent as CortexXCORPositive } from './XcorLightModeExpanded.svg';

export interface XcorBannerProps extends React.SVGProps<SVGSVGElement> {
  title?: string;
}

export const XcorBanner = ({ title = 'Cortex XCOR', ...props }: XcorBannerProps) => {
  const { theme } = useTheme();

  const Banner = theme.palette.mode === 'dark' ? CortexXCORNegative : CortexXCORPositive;

  return <Banner aria-label={title} role="img" {...props} />;
};
